<div class="h-screen flex flex-col mx-auto justify-center">
    <div class="loading-spinner">
        <div class="dots">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
        <!-- <div class="loading-text">Redirecting...</div> -->
    </div>
</div>
